export enum DefaultHeaderMobileLoginFormContextEnum {
    TOGGLELOGINFORM = 0,
    TOGGLEMOBILENAVIGATION = 1,
    TOGGLEMYACCOUNTNAVIGATION = 2,
    RESET = 3
}
